import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class EaProductModifyDecreaseUnitSliderModelService {
  public eaProductModifyDecreaseSlider: BehaviorSubject<boolean>;
  public addSidenav: MatSidenav;
  private activeSliderValue: string;
  sliderCloseRqt: Subject<boolean>;
  addModelData: BehaviorSubject<any>;

  constructor() {
    this.eaProductModifyDecreaseSlider = new BehaviorSubject(false);
    this.addModelData = new BehaviorSubject(EMPTY);
    this.sliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;
    this.activeSliderValue = value;

    if (value === 'EaProductModifyDecreaseUnitSlider') {
      this.eaProductModifyDecreaseSlider.next(true);
      this.addModelData.next(EMPTY);
      this.addSidenav.toggle();
    }
  }

  public setSideNav(sideNavObj: MatSidenav) {
    this.addSidenav = sideNavObj;
  }

  public close() {
    this.addModelData.next(EMPTY);
    this.eaProductModifyDecreaseSlider.next(false);
    this.addSidenav.close();
  }

  public setData<T>(obj: T) {
    this.addModelData.next(obj);
  }
}
